import React from 'react';
import HeaderTabButton from "../atoms/HeaderTabButton";
import styled from "styled-components";
import __ from '../../utils/translator';
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";

export default function HomepageTabBar() {
  return (
    <Container>
      <HeaderTabButton to={"/hot-now"}>
        {__("Hot now")}
      </HeaderTabButton>
      <HeaderTabButton to={"/to-complete"}>
        {__("To complete")}
      </HeaderTabButton>
      <HeaderTabButton to={"/never-seen"}>
        {__("Never seen")}
      </HeaderTabButton>
    </Container>
  )
}

const Container = styled.div`
  background-color: #FFFFFF;
  position: relative;
  z-index: 99;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #dadada;
  padding: ${themeResponsiveProperty(".5rem 1rem 0", ".5rem 3.75rem 0")};
  gap: 2rem;
`;
